module.exports = __webpack_public_path__ + "img/IMG_0419.1d98dffd.png";